module.exports = __webpack_public_path__ + "img/mp-retention.b8bf7789.jpg";